<template>
  <div
    class="bg-blobs"
    aria-hidden="true"
  >
    <div class="blob b1"></div>
    <div class="blob b2"></div>
    <div class="blob b3"></div>
  </div>
</template>

<script>
export default { name: 'BgBlobs' };
</script>
<style scoped lang="scss">
.bg-blobs {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.55;
  will-change: transform;
}

.blob.b1 {
  width: 560px;
  height: 560px;
  background: radial-gradient(circle, var(--pink), transparent 65%);
  top: -120px;
  right: -80px;
  animation: float1 14s ease-in-out infinite;
  opacity: 0.45;
}

.blob.b2 {
  width: 480px;
  height: 480px;
  background: radial-gradient(circle, var(--coral), transparent 65%);
  bottom: -100px;
  left: -100px;
  animation: float2 16s ease-in-out infinite;
  opacity: 0.55;
}

.blob.b3 {
  width: 380px;
  height: 380px;
  background: radial-gradient(circle, #ff9a4a, transparent 65%);
  top: 30%;
  left: 35%;
  opacity: 0.25;
  animation: float3 18s ease-in-out infinite;
}

.blob.b1,
.blob.b2,
.blob.b3 {
  animation-delay: 3s;
}

@keyframes float1 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(-40px, 40px) scale(1.08);
  }
}

@keyframes float2 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(50px, -30px) scale(1.06);
  }
}

@keyframes float3 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(-30px, 30px) scale(0.95);
  }
}

/* The drifting blobs are the dominant battery/heat cost on mobile: animating a
   `transform` on a layer that carries an 80px blur forces Safari to re-raster
   that full-screen blur on every frame, ×3, forever — even with no interaction.
   A *static* blurred layer is rasterized once and cached, so on small screens
   (and for users who ask for reduced motion) we stop the motion and release the
   compositor layer. The look is preserved; the continuous GPU work is not. */
@media (max-width: 720px), (prefers-reduced-motion: reduce) {
  .blob.b1,
  .blob.b2,
  .blob.b3 {
    animation: none;
    will-change: auto;
  }
}
</style>
